import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionTitle } from './SectionTitle';
import { useCarousel } from '../../hooks/useCarousel';
import { reviews } from '../../data/artTherapy';
function initials(name: string) {
  return name.replace('.', '').split(' ').map(p => p[0]).join('');
}
export function Reviews() {
  const {
    trackRef
  } = useCarousel(reviews.length);
  return <section aria-labelledby="reviews-title" className="relative overflow-hidden bg-gradient-to-b from-cream to-peach py-14 md:py-20" data-id="element-232" data-mp="wq58a2xpqqbr">
      <span aria-hidden="true" className="absolute -right-24 top-40 h-72 w-72 rounded-full bg-[#F9E6DE]/70" data-id="element-233" data-mp="rqitvq65f41d" />
      <div className="relative px-5" data-id="element-234" data-mp="msr16txojdw4">
        <SectionTitle id="reviews-title" subtitle="Fordított vélemények: eredetileg más nyelveken íródtak." data-id="element-235" data-mp="ht5rppkvvn55">
          Mit mondanak, akik kipróbálták
        </SectionTitle>
      </div>

      <div ref={trackRef} className="no-scrollbar relative mx-auto mt-8 flex max-w-6xl snap-x snap-mandatory gap-5 overflow-x-auto scroll-smooth px-[12%] pb-4 sm:px-[25%] lg:px-8" aria-label="Vélemények" data-id="element-236" data-mp="2h45pr7eyf7aa">
        {reviews.map(r => <article key={r.name} className="flex w-[76vw] max-w-[330px] shrink-0 snap-center flex-col rounded-3xl border border-[#F1E6E0] bg-white p-6 shadow-[0_10px_30px_-20px_rgba(74,58,53,0.4)]" data-id="element-237" data-mp="1kajd32xktxqv">
            <div className="flex items-center gap-4" data-id="element-238" data-mp="1adevlgeoeqge">
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-lavender-soft font-display text-lg font-bold text-lavender-deep ring-2 ring-lavender" aria-hidden="true" data-id="element-239" data-mp="1y2hc2kxkqd9b">
                {initials(r.name)}
              </span>
              <div data-id="element-240" data-mp="1ta6brgyx8pg8">
                <div className="flex gap-0.5 text-gold" aria-label="5 csillag" data-id="element-241" data-mp="1t9o5rsmgiwv4">
                  {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-242" data-mp="2gyphboql6o4m" data-mpi={i} />)}
                </div>
                <p className="mt-1 font-display text-lg font-bold text-ink" data-id="element-243" data-mp="2vmh7pyi5v3qx">{r.name}</p>
              </div>
            </div>
            <blockquote className="mt-4 text-[17px] italic leading-relaxed text-body" data-id="element-244" data-mp="2qopgl6pcblns">{r.quote}</blockquote>
          </article>)}
      </div>
    </section>;
}